var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('div',{staticClass:"d-flex align-center"},[_vm._v(" Json2Postman ")])]),_c('v-main',[_c('Home')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }